import { AyurmaStrings } from "./en";

// Russian. Typed against AyurmaStrings — omitting any key fails the build and
// names the exact path.
export const ayurmaRu: AyurmaStrings = {
  sections: {
    coverResults: "Метаболическая оценка",
    caloricNutrition: "Калорийный баланс и питание",
    nutritionGuide: "Руководство по питанию",
    movementPlan: "План движения",
    sourcesDisclaimer: "Научные источники",
  },

  cover: {
    title: "Метаболическая оценка",
    subtitle: "Отчёт об уровне метаболизма в покое (RMR)",
    resultsHeading: "Ваши результаты",
  },

  patientInfo: {
    name: "Имя",
    testType: "Тип теста",
    testTypeValue: "Оценка в состоянии покоя (RMR)",
    gender: "Пол",
    date: "Дата",
    weight: "Вес",
    activityLevel: "Уровень активности",
    height: "Рост",
    goal: "Цель",

    units: {
      kg: "кг",
      lbs: "фунт",
      cm: "см",
      ft: "фт",
      in: "дюйм",
    },

    genders: {
      male: "Мужской",
      female: "Женский",
    },

    exerciseFrequency: {
      none: "Нет",
      // "×" rather than "раз/раза": Russian declines the noun by count (1 раз,
      // 3 раза, 5 раз) and one template cannot cover 1-7.
      perWeek: "{count} × в неделю",
    },

    goals: {
      muscleDevelopment: "Развитие мышечной массы",
      strengthDevelopment: "Развитие силы",
      endurancePerformance: "Результаты в видах спорта на выносливость",
      longevity: "Долголетие",
      bodyRecomposition: "Рекомпозиция тела",
      dynamicPerformance: "Результаты в динамических видах спорта",
    },
  },

  glossary: {
    heading: "Ключевые показатели (в покое)",
    terms: {
      RER: {
        term: "RER",
        text: "Дыхательный коэффициент — показывает, углеводы или жиры используются как топливо",
      },
      VO2: {
        term: "VO2",
        text: "Окисление жиров — использование жиров для энергии в покое",
      },
      VCO2: {
        term: "VCO2",
        text: "Окисление углеводов — использование углеводов для энергии в покое",
      },
      VT: {
        term: "VT",
        text: "Дыхательный объём — объём воздуха за один вдох и выдох",
      },
      BF: {
        term: "BF",
        text: "Частота дыхания — число вдохов в минуту",
      },
      VE: {
        term: "VE",
        text: "Минутная вентиляция — объём воздуха, проходящий за минуту",
      },
    },
  },

  metrics: {
    ventilationEfficiency: {
      name: "Эффективность вентиляции лёгких",
      description:
        "Способность лёгких усваивать кислород и выводить углекислый газ",
    },
    breathingCoordination: {
      name: "Координация дыхания",
      description:
        "Способность поддерживать ровное и эффективное дыхание в состоянии покоя",
    },
    fatBurningEfficiency: {
      name: "Эффективность жиросжигания",
      description:
        "Способность клеток использовать жир в качестве источника энергии",
    },
    metabolicRate: {
      name: "Скорость метаболизма",
      description: "Калории, которые организм сжигает в состоянии покоя",
    },
    metabolicFlexibility: {
      name: "Метаболическая гибкость",
      description:
        "Способность быстро переключаться между жирами и углеводами как источниками энергии",
    },
    sympatheticParasympathetic: {
      name: "Симпатическая / парасимпатическая активация",
      description:
        "Баланс между двумя основными отделами вашей вегетативной нервной системы",
    },
    lungUtilization: {
      name: "Использование объёма лёгких",
      description:
        "Сколько процентов объёма лёгких вы используете в состоянии покоя",
    },
    heartRateVariability: {
      name: "Вариабельность сердечного ритма (ВСР)",
      description: "Работа сердечно-сосудистой системы в состоянии покоя",
    },
    oxygenDelivery: {
      name: "Доставка кислорода",
      description: "",
    },
    respiratoryCapacity: {
      name: "Дыхательная ёмкость",
      description: "",
    },
  },

  severity: {
    howToRead: "Как читать ваши результаты",
    range: { low: "Низкая", high: "Высокая" },
    ticks: {
      severe: "Сильное ограничение",
      limitation: "Ограничение",
      neutral: "Нейтрально",
      good: "Хорошо",
      excellent: "Отлично",
    },
    bands: {
      severe: { label: "КРИТИЧНО", range: "0–20%" },
      limitation: { label: "ОГРАНИЧЕНИЕ", range: "21–40%" },
      neutral: { label: "НЕЙТРАЛЬНО", range: "41–60%" },
      good: { label: "ХОРОШО", range: "61–80%" },
      excellent: { label: "ОТЛИЧНО", range: "81–100%" },
    },
  },

  caloric: {
    heading: "Калорийный баланс",
    burnTitle: "КАЛОРИИ, КОТОРЫЕ ВЫ СЖИГАЕТЕ (ККАЛ/ДЕНЬ)",
    eatTitle: "КАЛОРИИ, КОТОРЫЕ СЛЕДУЕТ ПОТРЕБЛЯТЬ (ККАЛ/ДЕНЬ)",
    trainingDays: "Дни тренировок",
    routineDays: "Дни обычной активности",
  },

  macros: {
    heading: "Дневник макронутриентов",
    names: { protein: "Белки", carbs: "Углеводы", fat: "Жиры" },
    units: { kcal: "ккал", g: "г" },
    trainingDays: "Дни тренировок",
    routineDays: "Дни обычной активности",
  },

  recommendations: {
    heading: "Рекомендации",
    rows: {
      mealFrequency: "Частота приёмов пищи",
      timing: "Время приёма",
      hydration: "Гидратация",
      infusions: "Настои",
      aroma: "Ароматерапия",
    },
  },

  nutritionGuide: {
    heading: "Руководство по питанию",
    subtitle: "Составлено вашим специалистом AyurMa.",
    eatLimitAvoidHeading: "Принимать пищу / Ограничить / Избегать",
    columns: {
      eat: "ПРИНИМАТЬ ПИЩУ",
      limit: "ОГРАНИЧИТЬ",
      avoid: "ИЗБЕГАТЬ",
    },
    otherRecommendations: "Другие рекомендации",
    supplements: "Добавки",
  },

  movement: {
    heading: "План движения",
    subtitle: "Два дня в неделю для каждой категории.",
    yoga: {
      label: "Йога",
      hint: "Выполнять в предписанных положениях, с указанным количеством повторений и практик.",
      columns: {
        posture: "ПОЗА / ПРАКТИКА",
        reps: "ПОВТОРЫ / ДЛИТЕЛЬНОСТЬ",
        notes: "ЗАМЕТКИ",
      },
    },
    aerobic: {
      label: "АЭРОБНЫЕ НАГРУЗКИ",
      rows: {
        briskWalking: "Быстрая ходьба",
        swimming: "Плавание",
        cycling: "Велосипед",
        other: "Другое",
      },
    },
    strength: {
      label: "СИЛОВЫЕ ТРЕНИРОВКИ",
      rows: {
        floorExercises: "Упражнения на полу",
        calisthenics: "Калистеника",
        freeWeights: "Свободные веса",
        other: "Другое",
      },
    },
  },

  footer: {
    brandLabel: "{company} · Метаболическое здоровье",
  },

  qr: {
    caption:
      "Отсканируйте, чтобы узнать больше о симпатической / парасимпатической активации",
  },

  sources: {
    heading: "Научные источники",
    originalLanguageNote:
      "Источники приведены на языке оригинальной публикации.",
    disclaimerLabel: "Отказ от ответственности:",
    disclaimerBody:
      "Настоящая оценка/отчёт предназначена исключительно для информационных целей и ни при каких обстоятельствах не должна рассматриваться как замена профессиональной медицинской консультации, диагностики или лечения. Прежде чем начинать любую программу упражнений и/или менять рацион и/или привычки на основании информации, представленной в настоящей оценке/отчёте, вам необходимо проконсультироваться с вашим врачом и/или семейным доктором. {company} не гарантирует, что настоящая оценка/отчёт приведёт к какому-либо улучшению состояния вашего здоровья и физической формы. Вы соглашаетесь с тем, что участие в любой тренировочной программе, физических упражнениях или активности может повысить риск физической травмы в зависимости от характера, частоты, интенсивности и продолжительности тренировочной программы, физических упражнений или активности. Вы соглашаетесь с тем, что, участвуя в любой тренировочной программе, физических упражнениях или активности, вы делаете это на свой собственный риск и принимаете на себя риск любых травм и/или ущерба, которые вы можете понести.",
  },

  langPicker: {
    label: "Язык отчёта",
  },
};
